export const TEXT_CONTENT_TYPE = 'TEXT';
export const MARKDOWN_CONTENT_TYPE = 'MARKDOWN';

export const TILE_CONTENT_NAME = 'Tile Content';
export const SUBHEADER_CONTENT_NAME = 'Subheader';
